'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
var legacyParse_1 = require('../legacyParse')
function legacyParseMap(array) {
  return array.map(function(item) {
    return legacyParse_1.default(item)
  })
}
exports.default = legacyParseMap
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@date-fns/upgrade/v2/legacyParseMap/index.js
// module id = 653
// module chunks = 10